// Icon-Bibliothek für Leistungen — kuratierte Liste passender Lucide-Icons
import {
  Stethoscope, Baby, Leaf, Heart, Sparkles, Microscope,
  Activity, Shield, ShieldCheck, Users, Cross, Ribbon,
  Flower, Flower2, Syringe, Pill, Thermometer, Calendar,
  Sun, Moon, Star, Dna, Brain,
  Mail, FileText, CalendarCheck, Video, Receipt,
} from "lucide-react";

// Map: icon-key → Lucide-Component + Anzeigename
export const SERVICE_ICONS = {
  stethoscope: { component: Stethoscope, label: "Stethoskop" },
  baby: { component: Baby, label: "Baby" },
  leaf: { component: Leaf, label: "Blatt" },
  heart: { component: Heart, label: "Herz" },
  sparkles: { component: Sparkles, label: "Funkeln" },
  microscope: { component: Microscope, label: "Mikroskop" },
  activity: { component: Activity, label: "Aktivität" },
  shield: { component: Shield, label: "Schild" },
  "shield-check": { component: ShieldCheck, label: "Schild-Check" },
  users: { component: Users, label: "Team" },
  cross: { component: Cross, label: "Kreuz" },
  ribbon: { component: Ribbon, label: "Schleife" },
  flower: { component: Flower, label: "Blume" },
  "flower-2": { component: Flower2, label: "Blume 2" },
  syringe: { component: Syringe, label: "Spritze" },
  pill: { component: Pill, label: "Tablette" },
  thermometer: { component: Thermometer, label: "Thermometer" },
  calendar: { component: Calendar, label: "Kalender" },
  sun: { component: Sun, label: "Sonne" },
  moon: { component: Moon, label: "Mond" },
  star: { component: Star, label: "Stern" },
  dna: { component: Dna, label: "DNA" },
  brain: { component: Brain, label: "Gehirn" },
  mail: { component: Mail, label: "Brief" },
  "file-text": { component: FileText, label: "Dokument" },
  "calendar-check": { component: CalendarCheck, label: "Termin" },
  video: { component: Video, label: "Video" },
  receipt: { component: Receipt, label: "Beleg" },
};

export const ICON_KEYS = Object.keys(SERVICE_ICONS);

export function getIconComponent(key) {
  return SERVICE_ICONS[key]?.component || Stethoscope;
}
